




























































































































import BaseComponent from '@/components/base-component.vue';
import UiTableContainer from '@/components/UI/table-container.vue';
import * as resize from '@/subjects/resize';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ContactForm from './contact-form.vue';
import UiSelectContact from './select-contact.vue';
import * as service from '@/services/crm-contact';

@Component({
  components: {
    UiTableContainer,
    ContactForm,
    UiSelectContact
  }
})
export default class ContactRelationshipTable extends BaseComponent {
  @Prop()
  value: any;

  @Prop()
  edit: any;

  @Prop({ default: 'Vincular contato existente' })
  comboContactLabel: string;

  @Prop({ default: true })
  showAddContact: boolean;

  @Prop()
  idInstitutionSelect: number;
  
  @Prop()
  idInstitutionAddContact: number;

  contacts: any[];
  idSelected = null;
  formOpen = false;
  contactEdit = false;
  key = 0;

  idsContactNotIn = null;
  idContactSelected = null;

  smallScreen: boolean = resize.isXsOrSmSizeScreen();

  public headersContact: any = [
    { text: 'Nome', value: 'nome', sortable: true },
    { text: 'Celular ou Telefone', value: 'celular', sortable: false },
    { text: 'Email', value: 'email', sortable: false },
    { text: 'Hierarquia', value: 'nivelHierarquico', sortable: false },
    { text: 'Função', value: 'funcao', sortable: false },
    { text: '', value: '', sortable: false, width: '30' }
  ];

  public $refs!: {
    form: HTMLFormElement;
  };

  @Watch('value', { immediate: true })
  onChangeValue(v) {
    this.contacts = Object.assign([], v);
    this.updateIdsContactNotIn();
    this.key++;
  }

  mounted() {}

  newItem(item, edit) {
    this.idSelected = null;
    this.formOpen = true;
    this.contactEdit = true;
  }

  openItem(item, edit) {
    this.idSelected = item.id;
    this.formOpen = true;
    this.contactEdit = edit;
  }

  removeItem(item) {
    this.contacts.splice(
      this.contacts.findIndex((c) => c.id == item.id),
      1
    );
    this.$emit('input', Array.from(this.contacts));
  }

  onCloseForm() {
    this.formOpen = false;
  }

  onAfterSave(item) {
    this.formOpen = false;
    this.$emit('afterSave');

    let cont = this.contacts.find((c) => c.id == item.id);
    if (!cont) {
      cont = new Object();
      cont.id = item.id;
      this.contacts.push(cont);
    }
    cont.nome = item.nome;
    cont.celular = item.celular;
    cont.email = item.email;
    cont.funcao = item.funcao;
    cont.nivelHierarquico = item.nivelHierarquico;

    this.$emit('input', Array.from(this.contacts));
  }

  @Watch('idContactSelected')
  onIdContactSelected(id) {
    if (!id) {
      return;
    }
    service.getCrmContactDetails(id).subscribe(
      (res) => {
        let cont: any = {};
        cont.id = res.id;
        this.contacts.push(cont);
        cont.nome = res.nome;
        cont.celular = res.celular;
        cont.email = res.email;
        cont.funcao = res.funcao;
        cont.nivelHierarquico = res.nivelHierarquico;

        this.idContactSelected = null;
        this.updateIdsContactNotIn();

        this.$emit('input', Array.from(this.contacts));
      },
      (error) => {}
    );
  }

  updateIdsContactNotIn() {
    this.idsContactNotIn = this.contacts.map((c) => c.id);
  }
}
